import React, { useEffect, useMemo } from "react";
import Sidebar from "./side-bar/side-bar";
import { MenuItem, Permission } from "./side-bar/types/menu-items";
import { Outlet } from "react-router-dom";
import "./main-layout.scss";
import { useDispatch, useSelector } from "react-redux";
import { footerItems, menuItems } from "./side-bar/types/side-bar";
import { useLogin } from "../../common/hooks/useUser";
import _ from "lodash";
import { getSupportTickets } from "../../api/admin/communication-management";

const AdminMainLayout: React.FC = () => {
  const SUPER_TENANT = "SuperTenant";
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state: any) => state?.session?.userDetails?.roles?.rolePermissions
  );

  const tenantDetails = useLogin();

  const currentUserRoleId = useMemo(() => {
    return tenantDetails?.userDetails?.roles?.id;
  }, [tenantDetails]);

  const currentUserType = tenantDetails?.tenantDetails?.tenantType;

  const filterMenuByPermissions = (
    menuItems: MenuItem[] | undefined,
    permissions: Permission[]
  ): MenuItem[] => {
    if (!menuItems) return [];
    // if (!permissions) return menuItems;

    return menuItems.filter((menu) => {
      const module: any = permissions?.find(
        (perm: any) => perm?.resource === menu?.moduleName
      );

      let hasMainMenuPermission: boolean = false;

      // If menu doesn't have a moduleName, allow access (like Dashboard)
      if (!menu.moduleName) {
        hasMainMenuPermission = true;
      }
      // If menu has moduleName, check permissions
      else if (module) {
        // If module exists in permissions, check read access (default to true if scopes not defined)
        hasMainMenuPermission = !module.scopes || module.scopes.read === true;
      } else {
        hasMainMenuPermission = false;
      }

      // const hasMainMenuPermission =
      //   !menu.moduleName || module?.permissions?.includes("read") || false;

      if (
        menu?.permissionRole?.length &&
        !menu.permissionRole.includes(currentUserRoleId)
      ) {
        return false;
      }
      if (menu?.onlyShowTOAFP) {
        return currentUserType === SUPER_TENANT && hasMainMenuPermission;
      }
      if (menu.subMenu) {
        menu.subMenu = filterMenuByPermissions(
          menu.subMenu,
          module?.subresources
        );

        return hasMainMenuPermission && menu.subMenu.length > 0;
      }

      return hasMainMenuPermission;
    });
  };
  const fetchSupport = async (type: string) => {
    try {
      const response = await getSupportTickets();
      if (response.data?.success) {
        const count = response.data?.data?.data?.totalRecords || 0;
        dispatch({
          type: `SUPPORT:${type}`,
          payload: { count },
        });
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchSupport("INITIALIZE_ADMIN_SUPPORT_COUNT");
    const intervalLead = setInterval(() => {
      fetchSupport("SET_ADMIN_SUPPORT_COUNT");
    }, 300000);

    return () => clearInterval(intervalLead);
  }, []);

  const filterMenu = _.cloneDeep(menuItems);
  const footerMenu = _.cloneDeep(footerItems);
  // const menuFilterItems = filterMenuByPermissions(filterMenu, permissions);
  const menuFilterItems = filterMenu;
  //   const footerFilterItems = filterMenuByPermissions(footerMenu, permissions);
  const footerFilterItems = footerMenu;
  return (
    <Sidebar menuItems={menuFilterItems} footerItems={footerFilterItems} />
  );
};

export default AdminMainLayout;
